'use client';
import NearbyScreen from '@/screen/feed/view/nearby';

const NearbyPage = () => {
  return <NearbyScreen />;
};

export default NearbyPage;
